import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { selectors as memberSelectors } from 'member-reducer'
import * as memberActions from 'member-actions'
import * as apiActions from 'api-actions'
import * as LS from 'local-storage'

const propTypes = {
  checkoutComplete: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  clearCheckoutComplete: PropTypes.func.isRequired,
  clearStripePaymentIntent: PropTypes.func.isRequired,
  deleteStripePaymentIntent: PropTypes.func.isRequired,
}

// Clears any existing Stripe payment intent from localStorage and the store
// when a payment flow is entered. This prevents cross-flow reuse of payment
// intents (e.g. a join flow intent being reused in a gift flow) and stale/
// expired intents from being carried over. If checkout is complete, the intent
// was already captured by Stripe and cannot be deleted, so we only clear
// local state. Otherwise we also cancel the intent on Stripe to avoid orphans.
// Always resets checkoutComplete so the flag doesn't carry over to the next
// flow (preventing abandoned intents from being skipped).
function StripePaymentIntentReset({
  checkoutComplete,
  children,
  clearCheckoutComplete,
  clearStripePaymentIntent,
  deleteStripePaymentIntent,
}) {
  useEffect(() => {
    if (checkoutComplete) {
      clearCheckoutComplete()
    }

    const storedPaymentIntent = LS.getStripePaymentIntent()

    if (!storedPaymentIntent?.payment_intent_id) return

    clearStripePaymentIntent()

    if (!checkoutComplete) {
      deleteStripePaymentIntent(storedPaymentIntent.payment_intent_id)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return children
}

StripePaymentIntentReset.propTypes = propTypes

function mapStateToProps(state) {
  return {
    checkoutComplete: memberSelectors.checkoutComplete(state),
  }
}

const mapDispatchToProps = {
  clearCheckoutComplete: memberActions.clearCheckoutComplete,
  clearStripePaymentIntent: memberActions.clearStripePaymentIntent,
  deleteStripePaymentIntent: apiActions.deleteStripePaymentIntent,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  StripePaymentIntentReset,
)
